import { render } from "./GrantComponent.vue?vue&type=template&id=32d8c71b&scoped=true"
import script from "./GrantComponent.vue?vue&type=script&lang=js"
export * from "./GrantComponent.vue?vue&type=script&lang=js"

import "./GrantComponent.vue?vue&type=style&index=0&id=32d8c71b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d8c71b"]])

export default __exports__